import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { COLOR_ORANGE } from '../../../assets/styles/colors';

export const PaginationSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PaginationButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 15px;

  .arrow-wrap {
    padding-left: 16px;
    align-items: center;
    display: flex;
  }
  button {
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${rgba(COLOR_ORANGE, 0.2)};
    &:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      margin-right: 1px;
    }
    &:last-child {
      margin-left: 1px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
`;

export const SizeChangerSC = styled.div``;

export const SizeChangeButton = styled.button`
  border: none;
  border-radius: 6px;

  margin: 8px;

  text-align: center;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;

  ${({ active }) =>
    active
      ? css`
          color: #ffffff;
          background: ${COLOR_ORANGE};
        `
      : css`
          color: ${COLOR_ORANGE};
          background: ${rgba(COLOR_ORANGE, 0.2)};
        `};
`;
